import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface SyncSliceState {
  isOnline: boolean
}

const initialState: SyncSliceState = {
  isOnline: navigator.onLine,
}

const syncSlice = createSlice({
  name: 'sync',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload
    },
  },
})

export const { setOnlineStatus } = syncSlice.actions

export default syncSlice.reducer
